import angular from 'angular';
import relativeRiskDetails from '../relativeRiskDetails';
import impactAnalysisGraph from '../impactAnalysisGraph';
import recoveryPointObjectives from '../recoveryPointObjectives';
import controller from './impact-analysis-process.controller';
import directive from './impact-analysis-process.directive';


export default angular.module('app.components.advisory.bcp.impactAnalysisProcess', [
  relativeRiskDetails,
  impactAnalysisGraph,
  recoveryPointObjectives,
])
  .directive('bcpImpactAnalysisProcess', directive)
  .controller('ImpactAnalysisProcessController', controller)
  .name;

console.log('app.components.advisory.bcp.impactAnalysisProcess created');
